import { Col, Flex, Row } from "antd";
import { useEffect, useState } from "react";
import { getStoreList } from "../../components/apiRepository/CreateStoreRepository";
import Footer from "../../components/v2/Footer/Footer";
import {
  ACTIONTYPES,
  useStore,
  useStoreDispatch,
} from "../../context/CreateStoreContext";
import Navigation from "./Navigation/Navigation";
import style from "./StoreDashboard.module.css";
import StoreDetails from "./StoreDetails/StoreDetails";
import StoreList from "./StoreList/StoreList";

export default function StoreDashboard() {
  const {
    loginDetails: { token = null, storeDetails = {} },
  } = useStore();
  const [storeList, setStoreList] = useState([]);
  const dispatch = useStoreDispatch();
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    dispatch({
      type: ACTIONTYPES.ADMIN_SELECTEDSTORE,
      data: null,
    });

    let isMounted = true;
    const controller = new AbortController();

    const fetchStoreList = async () => {
      try {
        const list = await getStoreList({
          storeId: storeDetails?.id,
          header: {
            signal: controller.signal,
          },
        });

        const parentStore = list.find(
          (store) => store?.accountType === "OWNER",
        );

        setStoreList(list);

        dispatch({
          type: ACTIONTYPES.ADMIN_PARENTSTORE,
          data: parentStore,
        });

        dispatch({
          type: ACTIONTYPES.ADMIN_SELECTEDSTORE,
          data: list?.[0] || null,
        });
      } catch (err) {
        console.error(err);
        setHasError(true);
      } finally {
        setLoading(false);
      }
    };

    isMounted && token && storeDetails?.id && fetchStoreList();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [token, storeDetails?.id]);

  return (
    <Flex vertical style={{ minHeight: "100vh" }}>
      <Row className={style.Header} align="middle">
        <Col
          xs={24}
          sm={{ span: 22, offset: 1 }}
          lg={{ span: 22, offset: 1 }}
          xxl={{ span: 16, offset: 4 }}
        >
          <Navigation />
        </Col>
      </Row>

      <Row style={{ flex: 1 }}>
        <Col
          xs={24}
          sm={{ span: 7, offset: 1 }}
          lg={{ span: 7, offset: 1 }}
          xxl={{ span: 5, offset: 4 }}
        >
          <StoreList
            storeList={storeList}
            loading={loading}
            hasError={hasError}
          />
        </Col>
        <Col
          xs={24}
          sm={{ span: 15, offset: 1 }}
          lg={{ span: 15, offset: 1 }}
          xxl={{ span: 14, offset: 1 }}
          className={style.RightContainer}
        >
          <Row>
            <Col
              xs={{ span: 22, offset: 1 }}
              lg={{ span: 23, offset: 0 }}
              xxl={18}
            >
              <StoreDetails loading={loading} hasError={hasError} />
            </Col>
          </Row>
        </Col>
      </Row>

      <Footer />
    </Flex>
  );
}
